export const MAX_TILES_LIMIT = 8;
export const NAME_MAX_LENGTH = 25;
export const TABNAME_MAX_LENGTH = 40;

export const DASHBOARD_PREFIX = 'dashboard-';
